export enum ETypes {
  User = 'User',
  Account = 'Account',
  Operation = 'Operation',
}
